import { render } from "./ProductDetailsForm.vue?vue&type=template&id=41d951e8"
import script from "./ProductDetailsForm.vue?vue&type=script&lang=js"
export * from "./ProductDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__